import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import { cloneElement } from 'react';
import cn from 'classnames';
import { ICON_SIZES } from '../utils/constants';
import { Tooltip } from '../tooltip/index';
import { IconUiCloseFilled } from '..';
var ICON_SIZE = ICON_SIZES.small;
var styles = {
  "default": {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '8px 8px 8px 12px',
    color: 'grey.10',
    backgroundColor: 'grey.4',
    borderRadius: '32px',
    lineHeight: 1,
    fontSize: 1,
    fontStyle: 'normal',
    fontWeight: 'regular',
    maxWidth: '100%'
  },
  childrenContainer: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'noWrap'
  },
  disabled: {
    backgroundColor: 'grey.4',
    color: 'grey.7',
    pointerEvents: 'none'
  },
  editable: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'grey.5',
      'svg:last-of-type': {
        color: 'blue.dark'
      }
    },
    '&:active': {
      backgroundColor: 'grey.6',
      'svg:last-of-type': {
        color: 'blue.darker'
      }
    }
  },
  headingIcon: {
    marginRight: 2,
    minWidth: ICON_SIZE
  },
  closeIcon: {
    marginLeft: 2,
    minWidth: ICON_SIZE
  },
  label: {
    display: 'inline'
  },
  subText: {
    fontSize: '12px',
    color: 'grey.9'
  }
};
var LabelTag = function LabelTag(_ref) {
  var children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    icon = _ref.icon,
    readOnly = _ref.readOnly,
    onClick = _ref.onClick,
    subText = _ref.subText,
    maxWidth = _ref.maxWidth,
    withTooltip = _ref.withTooltip,
    delayTooltip = _ref.delayTooltip,
    shouldTruncateLabel = _ref.shouldTruncateLabel;
  var isEditable = !readOnly && !disabled;
  var labelElement = function labelElement() {
    return jsx("div", {
      sx: styles.label
    }, jsx("div", {
      sx: shouldTruncateLabel && _objectSpread(_objectSpread({}, styles.childrenContainer), {}, {
        maxWidth: maxWidth
      })
    }, children), subText && jsx("div", {
      sx: _objectSpread(_objectSpread(_objectSpread({}, styles.subText), styles.childrenContainer), {}, {
        maxWidth: maxWidth
      })
    }, subText));
  };
  return jsx("div", {
    className: cn('zenit', className),
    sx: _objectSpread(_objectSpread(_objectSpread({}, styles["default"]), isEditable && styles.editable), disabled && styles.disabled),
    onClick: isEditable ? onClick : undefined
  }, icon && /*#__PURE__*/cloneElement(icon, {
    sx: _objectSpread(_objectSpread({}, styles.headingIcon), {}, {
      opacity: disabled ? 0.5 : 1
    }),
    disabled: disabled
  }), withTooltip ? jsx(Tooltip, {
    position: "top",
    text: subText ? "".concat(children, " - ").concat(subText) : "".concat(children),
    delay: delayTooltip
  }, labelElement()) : labelElement(), !readOnly && jsx(IconUiCloseFilled, {
    sx: styles.closeIcon
  }));
};
LabelTag.defaultProps = {
  readOnly: false,
  subText: '',
  maxWidth: 300,
  withTooltip: false,
  shouldTruncateLabel: true
};
export { LabelTag };